/* eslint-disable */
import { FaFacebookF, FaLinkedinIn, FaTwitter, FaInstagram, FaYoutube, FaTiktok, FaPinterestP, FaSnapchatGhost } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { AppStoreButton, GoogleStoreButton } from '../BoxRevealDemo';
import ExternalLink from '../../ExternalLink';
import './index.scss';
import { getPublicAssetUrl } from '../../../utils/publicAsset';

const socials = [
  { icon: <FaInstagram />, url: 'https://instagram.com/realityfence?igshid=OGQ5ZDc2ODk2ZA==', name: 'Instagram' },
  { icon: <FaLinkedinIn />, url: 'https://www.linkedin.com/company/realityfence/', name: 'LinkedIn' },
  { icon: <FaTwitter />, url: 'https://twitter.com/realityfence', name: 'Twitter' },
  { icon: <FaFacebookF />, url: 'https://www.facebook.com/profile.php?id=100089795147096&mibextid=LQQJ4d', name: 'Facebook' },
  { icon: <FaYoutube />, url: 'https://youtube.com/@realityfence', name: 'YouTube' },
  { icon: <FaTiktok />, url: 'https://www.tiktok.com/@realityfence?_t=8eEN01ILXig&_r=1', name: 'TikTok' },
  { icon: <FaPinterestP />, url: 'https://www.pinterest.com/realityfence/', name: 'Pinterest' },
  { icon: <FaSnapchatGhost />, url: 'https://www.snapchat.com/add/realityfence', name: 'Snapchat' },
];

const companyLinks = [
  { title: 'About', url: '/aboutus' },
  { title: 'Contact', url: '/contactus' },
  { title: 'Story', url: '/aboutus' },
];

const supportLinks = [
  { title: 'Blog', url: '/blog' },
  { title: 'RealityFence EDU', url: '/edfence' },
  { title: 'FAQs', url: '/faqs' },
];

const legalLinks = [
  { title: 'Legal', url: '/legal' },
  { title: 'Privacy Policy', url: '/privacy-policy' },
  { title: 'Terms and Conditions', url: '/terms-and-conditions' },
];

function FooterLinkColumn({ title, links }: { title: string; links: { title: string; url: string }[] }) {
  return (
    <div>
      <h3 className="text-sm font-semibold uppercase tracking-wider text-white/60">{title}</h3>
      <ul className="mt-4 space-y-3">
        {links.map((link) => (
          <li key={link.title}>
            <Link to={link.url} className="text-[15px] text-white hover:text-white/80 transition-colors">
              {link.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Footer() {
  return (
    <footer className="bg-black">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Main footer content */}
        <div className="py-12 lg:py-16">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
            {/* Brand column */}
            <div className="lg:col-span-4">
              <Link to="/">
                <picture>
                  <source
                    media="(min-width: 768px)"
                    srcSet={getPublicAssetUrl('/assets/images/home/RF-Logo-White.svg')}
                    type="image/svg+xml"
                  />
                  <source
                    srcSet={getPublicAssetUrl('/assets/images/home/rf_logo_white_mobile_optimized.webp')}
                    type="image/webp"
                  />
                  <img
                    className="h-20 w-auto"
                    src={getPublicAssetUrl('/assets/images/home/rf_logo_white_mobile_optimized.png')}
                    alt="RealityFence"
                  />
                </picture>
              </Link>
              <p className="mt-4 max-w-xs text-[15px] leading-relaxed text-white/80">
                Helping fence contractors visualize, estimate, and close — faster.
              </p>

              {/* Social icons */}
              <div className="mt-6 flex items-center gap-3">
                {socials.map((social) => (
                  <ExternalLink
                    key={social.name}
                    href={social.url}
                    aria-label={social.name}
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
                  >
                    <span className="text-sm">{social.icon}</span>
                  </ExternalLink>
                ))}
              </div>
            </div>

            {/* Link columns */}
            <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:col-span-8">
              <FooterLinkColumn title="Company" links={companyLinks} />
              <FooterLinkColumn title="Support" links={supportLinks} />
              <FooterLinkColumn title="Legal" links={legalLinks} />

              {/* Contact column */}
              <div>
                <h3 className="text-sm font-semibold uppercase tracking-wider text-white/60">Contact</h3>
                <div className="mt-4 space-y-4">
                  <ExternalLink
                    href="https://www.google.com/maps/search/?api=1&query=24681+Northwestern+Hwy+Frontage+Rd,+Southfield,+MI+48075"
                    className="block text-[15px] leading-relaxed text-white hover:text-white/80 transition-colors"
                  >
                    24681 Northwestern Hwy
                    <br />Frontage Rd
                    <br />Southfield, MI 48075
                  </ExternalLink>
                  <div className="space-y-1">
                    <a href="tel:+13108617943" className="block text-[15px] text-white hover:text-white/80 transition-colors">
                      (310) 861-7943
                    </a>
                    <a href="mailto:hello@realityfence.com" className="block text-[15px] text-white hover:text-white/80 transition-colors">
                      hello@realityfence.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/15 py-6 flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-white/60">
            &copy; {new Date().getFullYear()} RealityFence. All rights reserved.
          </p>
          <div className="download-buttons flex items-center gap-3">
            <AppStoreButton />
            <GoogleStoreButton />
          </div>
        </div>
      </div>
    </footer>
  );
}
